import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgClockArrow = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 3C13.8078 3 15.4345 3.61689 16.9376 4.60079C18.4408 5.58468 19.6124 6.98312 20.3042 8.61927C20.996 10.2554 21.1771 12.0558 20.8244 13.7927C20.4717 15.5297 19.6011 17.1251 18.3228 18.3774C17.0444 19.6297 15.4157 20.4824 13.6426 20.8279C11.8695 21.1734 10.0316 20.9961 8.36141 20.3184C6.69118 19.6407 5.26361 18.493 4.25922 17.0205C3.25484 15.548 3 13.5873 3 11.8164C3 10.0454 3 13.0363 3 11.2653"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 12L3 10L1 12"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 7V12.5L9.5 15.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgClockArrow.displayName = 'SvgClockArrow';
export default SvgClockArrow;
